import React from 'react'
import { LazyLoadComponent } from 'react-lazy-load-image-component'
import PropTypes from 'prop-types'

import twicpicsSource from 'lib/utils/twicpics-source'

const Twicpics = ({
  src,
  className,
  dataAttr,
  alt,
  radius,
  dpr,
  height,
  width,
  onClick,
  onMouseLeave,
  onMouseEnter,
  passThrough,
  lazyLoad
}) => {
  const isWidthPercentage = typeof width === 'string' && width.includes('%')
  const isHeightPercentage = typeof height === 'string' && height.includes('%')
  const hasPercentage = isWidthPercentage || isHeightPercentage

  const imageWidth = hasPercentage ? 1200 : width
  const imageHeight = hasPercentage ? 900 : height || width

  const source = passThrough ? src : twicpicsSource(src, imageWidth, imageHeight || imageWidth, dpr)

  const effectiveHeight = height || width
  let backgroundSize

  if (passThrough) {
    backgroundSize = 'cover'
  } else if (hasPercentage) {
    backgroundSize = 'cover'
  } else {
    const widthValue = typeof width === 'number' ? `${width}px` : width
    const heightValue = typeof effectiveHeight === 'number' ? `${effectiveHeight}px` : effectiveHeight
    backgroundSize = `${widthValue} ${heightValue}`
  }

  const style = {
    width,
    height: height || width,
    backgroundImage: `url(${source})`,
    backgroundSize,
    backgroundPosition: 'center center',
    display: 'inline-block',
    borderRadius: radius
  }

  const handleClick = event => {
    if (onClick) {
      onClick(event)
    }
  }

  const divElement = (
    <div
      onMouseEnter={onMouseEnter}
      onMouseLeave={onMouseLeave}
      className={`div-img${className ? ' ' + className : ''}`}
      style={style}
      data-alt={alt}
      onClick={handleClick}
      data-attr={dataAttr}
    />
  )

  return lazyLoad ? <LazyLoadComponent>{divElement}</LazyLoadComponent> : divElement
}

Twicpics.propTypes = {
  src: PropTypes.string,
  className: PropTypes.string,
  dataAttr: PropTypes.string,
  alt: PropTypes.string.isRequired,
  radius: PropTypes.number,
  height: PropTypes.oneOfType([PropTypes.number, PropTypes.string]),
  dpr: PropTypes.number,
  width: PropTypes.number.isRequired,
  onClick: PropTypes.func,
  onMouseLeave: PropTypes.func,
  onMouseEnter: PropTypes.func,
  passThrough: PropTypes.bool,
  lazyLoad: PropTypes.bool
}

export default Twicpics
